import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import { trackVirtualPageView } from "../../utils/analytics"
import InsurancePlann from "./insuranceplan/insuranceplan"
import Hmo from "./insuranceplan/hmo"
import SelfPlay from "./insuranceplan/selfPay"
import NotSure from "./insuranceplan/notSure"
import Success from "./insuranceplan/success"
import Schedulappointment from "./insuranceplan/schedulappointment"
import Selfschedulappointment from "./insuranceplan/selfschedulappointment"
import Thankyou from "./insuranceplan/thankyou"
import ConfirmAppointment from "./insuranceplan/confirmAppointment"
const pathToStepInsu = {
  "start-scheduling": "StartScheduling",
  "schedule-booking": "Schedulappointment",
  "confirm-booking": "ConfirmAppointment",
  "booking-confirmed": "Success",
}

const stepInsuToPath = {
  StartScheduling: "start-scheduling",
  Schedulappointment: "schedule-booking",
  ConfirmAppointment: "confirm-booking",
  Success: "booking-confirmed",
}

const InsurancePlan = ({ apiData, nextStep, prevStep, setUser, user }) => {
  const getInitialStepInsu = () => {
    if (typeof window !== "undefined") {
      const currentPath = window.location.pathname.split("/").pop()
      return (
        pathToStepInsu[currentPath] ??
        (currentPath === "start-scheduling" ? "StartScheduling" : "PPO")
      )
    }
    return "PPO"
  }

  const [stepInsu, setStepInsu] = useState(getInitialStepInsu())

  const [openSlotsResults, setOpenSlotsResults] = useState([])
  const [appointmentDetails, setAppointmentDetails] = useState({
    date: "",
    starttime: "",
    endtime: "",
  })
  useEffect(() => {
    if (typeof window !== "undefined") {
      const currentPath = stepInsuToPath[stepInsu]
      if (currentPath) {
        const newUrl = `/welcomevisit/${currentPath}`
        if (window.location.pathname !== newUrl) {
          window.history.replaceState({ stepInsu }, "", newUrl)
          trackVirtualPageView()
        }
      }
    }
  }, [stepInsu])

  function setFunction(data) {
    setStepInsu(data)
    setUser({
      ...user,
      plan_coverage: data,
    })
  }
  switch (stepInsu) {
    case "PPO":
      return (
        <InsurancePlann
          apiData={apiData}
          prevStep={prevStep}
          setFunction={setFunction}
          setOpenSlotsResults={setOpenSlotsResults}
          setUser={setUser}
          user={user}
        />
      )
    case "HMO":
      return (
        <Hmo
          apiData={apiData}
          prevStep={prevStep}
          setFunction={setFunction}
          setUser={setUser}
          user={user}
        />
      )
    case "Self-Pay":
      return (
        <SelfPlay
          apiData={apiData}
          prevStep={prevStep}
          setFunction={setFunction}
          setOpenSlotsResults={setOpenSlotsResults}
          setUser={setUser}
          user={user}
        />
      )
    case "Not Sure":
      return (
        <NotSure
          apiData={apiData}
          prevStep={prevStep}
          setFunction={setFunction}
          setUser={setUser}
          user={user}
        />
      )
    case "Schedulappointment":
      return (
        <Schedulappointment
          apiData={apiData}
          openSlotsResults={openSlotsResults}
          setAppointmentDetails={setAppointmentDetails}
          setFunction={setFunction}
        />
      )
    case "ConfirmAppointment":
      return (
        <ConfirmAppointment
          appointmentDetails={appointmentDetails}
          prevStep={() => setStepInsu("Schedulappointment")}
          setFunction={setFunction}
        />
      )
    case "Success":
      return <Success setFunction={setFunction} />
    case "Thankyou":
      return <Thankyou />
    case "Selfschedulappointment":
      return (
        <Selfschedulappointment
          apiData={apiData}
          openSlotsResults={openSlotsResults}
          setAppointmentDetails={setAppointmentDetails}
          setFunction={setFunction}
        />
      )
    default:
      return (
        <div className="App">
          <h1>ftg</h1>
        </div>
      )
  }
}
InsurancePlan.propTypes = {
  apiData: PropTypes.object.isRequired,
  nextStep: PropTypes.func.isRequired,
  prevStep: PropTypes.func.isRequired,
  setUser: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
}
export default InsurancePlan
